let isValidPhone = function (phone) {
    phone = phone.replace(/[^0-9]/g, '')
    if (phone.length != 10) {
        return false
    } else {
        return true
    }
}

export default isValidPhone;
